import { Routes } from '@angular/router';
import { HasBasketGuard } from '@basket';
import { HasSelectedApplianceGuard } from '@registration';
import {
  errorRoutes,
  multiPlanChildRoutes,
  supportRoutes,
} from './shared-routes';

export const appRoutes: Routes = [
  {
    path: 'appliance-details',
    loadComponent: () =>
      import('@features/appliance-details').then(
        (module) => module.HomepageComponent,
      ),
  },
  {
    path: 'protection-details',
    loadComponent: () =>
      import('@features/single-plan').then(
        (module) => module.SinglePlanSaleComponent,
      ),
    canActivate: [HasBasketGuard],
  },
  {
    path: 'multi-plan',
    loadComponent: () =>
      import('@features/multi-plan').then(
        (module) => module.MultiPlanNavigationComponent,
      ),
    canActivate: [HasBasketGuard],
    children: multiPlanChildRoutes,
  },
  {
    path: 'contact-details',
    loadComponent: () =>
      import('@features/checkout').then(
        (module) => module.ContactDetailsComponent,
      ),
    canActivate: [HasSelectedApplianceGuard],
  },
  {
    path: 'direct-debit',
    loadComponent: () =>
      import('@features/checkout').then((module) => module.CheckoutComponent),
    canActivate: [HasBasketGuard],
  },
  {
    path: 'registration-confirmation',
    loadComponent: () =>
      import('@features/registration-confirmation').then(
        (module) => module.RegistrationConfirmationComponent,
      ),
  },
  {
    path: 'order-confirmation',
    loadComponent: () =>
      import('@features/order-confirmation').then(
        (module) => module.OrderConfirmationComponent,
      ),
  },
  ...errorRoutes,
  ...supportRoutes,
  {
    path: '**',
    redirectTo: 'appliance-details',
    pathMatch: 'full',
  },
];
